window.addEventListener("load", function () {
  const container = document.querySelector(".flickity-viewport");
  const img = container?.querySelector("img");

  if (container && img) {
    const updateHeight = () => {
      const ratio = img.naturalHeight / img.naturalWidth;
      const containerWidth = container.offsetWidth;
      const desiredHeight = containerWidth * ratio;

      const screenHeight = window.innerHeight;
      let maxHeightRatio = 0.98; // Varsayılan en büyük oran

      if (screenHeight <= 1024) {
        maxHeightRatio = 0.8;
      } else if (screenHeight <= 1366) {
        maxHeightRatio = 0.85;
      } else if (screenHeight <= 1720) {
        maxHeightRatio = 0.9;
      } else if (screenHeight <= 2000) {
        maxHeightRatio = 0.95;
      } else {
        maxHeightRatio = 0.98;
      }

      const maxHeight = screenHeight * maxHeightRatio;
      const adjustedHeight = Math.min(desiredHeight, maxHeight);

      console.log('minHeight==========>', adjustedHeight);
      console.log('maxHeight==========>', maxHeight);
      container.style.minHeight = adjustedHeight + "px";
      container.style.maxHeight = maxHeight + "px";
      container.style.height = "auto";

      console.log(`Yükseklik ayarlandı: ${adjustedHeight}px (max: ${maxHeight}px)`);
    };

    if (img.complete) {
      updateHeight();
    } else {
      img.onload = updateHeight;
    }

    window.addEventListener("resize", updateHeight);
  }
});
